// const createPlan = () => fetch(`${apiUrl}/plans/create`, {
//                 method: 'POST', headers: {
//                     'Content-Type': 'application/json', Authorization: `Bearer ${process.env.REACT_APP_API_TOKEN}`,
//                 }, body: JSON.stringify(body)
import axios from "axios";
import PaymnetStore from "../../store/paymnet-store";
import UserStore from "../../store/user-store";
import paymnetStore from "../../store/paymnet-store";
import {getUserPlans} from "./Plans/useGetPlans";
import {apiClient} from "../../AxiosConfig";

const apiUrl = process.env.REACT_APP_API_URL;

export const createPlan = async () => {
    const body = {
        tx_id: PaymnetStore.tx_id,
    }
    apiClient.post(`/v1/payment/stars-checkout`, body)
    .then(data => {
            if (data.status === 200 && data?.data?.status === "paid") {
                getUserPlans();
            }
            else {
                PaymnetStore.setPaymentStatus(false)
                PaymnetStore.setIsPaymentUrlOpened(false)
                PaymnetStore.setPaymentProcessed(false)
                PaymnetStore.setTxId(null)
                PaymnetStore.setPaymentUrl(null)
                PaymnetStore.resetTimer()
            }

        }
    )
}